import * as ActionTypes from 'actions/Powerbox';
import * as AuthActionTypes from 'actions/Auth';
import { get } from 'lodash';

const initialState = {
  powerboxList: [],
  powerbox: null,
  tableSorting: {
    sortBy: 'powerboxMac',
    sortDirection: 'ASC',
  },
  powerboxListPage: 0,
  tableFilter: {
    powerboxDisplayScope: '',
    search: '',
  },
};
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case AuthActionTypes.LOGOUT.SUCCESS:
      return { ...initialState };
    case ActionTypes.SET_POWERBOX_TABLE_FILTER:
      return { ...state, tableFilter: action.payload };
    case ActionTypes.SET_POWERBOX_TABLE_SORTING:
      return { ...state, tableSorting: action.payload };
    case ActionTypes.GET_POWERBOX_LIST.SUCCESS:
      return {
        ...state,
        powerboxList: get(action.payload, 'content'),
        powerboxListPage: get(action, 'payload.currentPage', 0),
        powerboxListPages: get(action, 'payload.totalPages', 0),
      };
    case ActionTypes.GET_POWERBOX.SUCCESS:
      return {
        ...state,
        powerbox: action.payload,
      };
    default:
      return state;
  }
}
